var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-around;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  white-space: pre-wrap;\n  line-height: 1.2em;\n  a {\n    font-weight: bold;\n    text-decoration: none;\n    color: ", ";\n    :hover {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  svg {\n    :hover {\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: none;\n  color: ", ";\n  :hover {\n    color: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  line-height: 1.2;\n  a {\n    color: ", ";\n    :hover {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  text-align: justify;\n  * {\n    margin: 15px 0;\n  }\n  a {\n    color: ", ";\n    :hover {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  max-width: none;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  line-height: 1.6;\n  max-width: 1400px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@rtm-ui/icon'), require('@rtm-ui/layout'), require('@rtm-ui/theme'), require('@rtm-ui/typography'), require('prop-types'), require('react'), require('styled-components')) : typeof define === 'function' && define.amd ? define(['exports', '@rtm-ui/icon', '@rtm-ui/layout', '@rtm-ui/theme', '@rtm-ui/typography', 'prop-types', 'react', 'styled-components'], factory) : (global = global || self, factory(global.footer = {}, global.RtmUiIcon, global.RtmUiLayout, global.RtmUiTheme, global.RtmUiTypography, global.PropTypes, global.React, global.styled));
})(this, function (exports, icon, layout, theme, typography, PropTypes, React, styled) {
  'use strict';

  PropTypes = PropTypes && Object.prototype.hasOwnProperty.call(PropTypes, 'default') ? PropTypes['default'] : PropTypes;
  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;
  styled = styled && Object.prototype.hasOwnProperty.call(styled, 'default') ? styled['default'] : styled;
  var Flex = styled(layout.Box)(_templateObject());
  var Container = styled(layout.Box)(_templateObject2());
  var LegalContainer = styled(Container)(_templateObject3());
  var DisclaimersBox = styled(layout.Box)(_templateObject4(), function (props) {
    return theme.getColor('text', props.theme);
  }, function (props) {
    return theme.getColor('linkHover', props.theme);
  });
  var FooterDisclaimersBox = styled(layout.Box)(_templateObject5(), function (props) {
    return theme.getColor('text', props.theme);
  }, function (props) {
    return theme.getColor('linkHover', props.theme);
  });
  var A = styled.a(_templateObject6(), function (props) {
    return theme.getColor('text', props.theme);
  }, function (props) {
    return theme.getColor('linkHover', props.theme);
  });
  var SocialWapper = styled(layout.Box)(_templateObject7(), function (props) {
    return theme.getColor('linkHover', props.theme);
  });
  var HoursInfo = styled(typography.Paragraph)(_templateObject8(), function (props) {
    return theme.getColor('text', props.theme);
  }, function (props) {
    return theme.getColor('linkHover', props.theme);
  });
  var FlexBox = styled(layout.Box)(_templateObject9());
  var InnerFlexBox = styled(layout.Box)(_templateObject10());

  var chunkArray = function chunkArray(myArray, chunkSize) {
    var results = [];

    while (myArray.length) {
      results.push(myArray.splice(0, chunkSize));
    }

    return results;
  };

  var FooterPolicySection = function FooterPolicySection(_ref) {
    var item = _ref.item;
    return (
      /*#__PURE__*/
      React.createElement(React.Fragment, null,
      /*#__PURE__*/
      React.createElement(FooterDisclaimersBox, null,
      /*#__PURE__*/
      React.createElement(typography.Small, {
        style: {
          whiteSpace: 'pre-line',
          lineHeight: '1.5em'
        },
        dangerousHTML: item
      })))
    );
  };

  var Footer = function Footer(_ref2) {
    var entity = _ref2.entity,
        disclaimers = _ref2.disclaimers,
        landing = _ref2.landing;
    var _entity$footer_items = entity.footer_items,
        links = _entity$footer_items.links,
        businessHourInfo = _entity$footer_items.businessHourInfo,
        footerPolicy = _entity$footer_items.footerPolicy;
    var socials = links.filter(function (l) {
      return l.kind === 'social';
    });
    var main = chunkArray(links.filter(function (l) {
      return l.kind === 'info';
    }), 4);
    var others = links.filter(function (l) {
      return l.kind === 'financial';
    });
    var legals = links.filter(function (l) {
      return l.kind === 'legal';
    });
    return (
      /*#__PURE__*/
      React.createElement(React.Fragment, null,
      /*#__PURE__*/
      React.createElement(layout.Box, {
        variant: "b"
      },
      /*#__PURE__*/
      React.createElement(Container, null,
      /*#__PURE__*/
      React.createElement(FlexBox, {
        py: landing ? [4, 5, '92px', '92px'] : '92px',
        px: [3, 3, 3, 4]
      },
      /*#__PURE__*/
      React.createElement(layout.Box, {
        mb: [3, 0, 5, 0],
        width: landing ? [1, 1, 1 / 3, 3 / 4] : [1, 1 / 2, 1 / 3, 1 / 5]
      },
      /*#__PURE__*/
      React.createElement(A, {
        href: "/"
      },
      /*#__PURE__*/
      React.createElement(icon.Logo, {
        width: 135,
        entityBrand: entity.brand
      }))), !landing &&
      /*#__PURE__*/
      React.createElement(SocialWapper, {
        mb: [3, 0, 5, 0],
        width: [1, 1 / 2, 1 / 3, 1 / 5]
      },
      /*#__PURE__*/
      React.createElement(typography.Paragraph, {
        weight: "bold",
        my: 1
      }, "FOLLOW US ON SOCIAL"), socials.map(function (item) {
        var iconName = item.name.toLowerCase();
        return (
          /*#__PURE__*/
          React.createElement(A, {
            key: iconName,
            href: item.url
          },
          /*#__PURE__*/
          React.createElement(icon.Icon, {
            glyph: iconName
          }))
        );
      })), !landing && main.map(function (subItems, index) {
        return (
          /*#__PURE__*/
          React.createElement(layout.Box, {
            mt: [3, 3, 0, 0],
            width: [1, 1 / 2, 1 / 3, 1 / 5],
            key: index
          }, // eslint-disable-next-line react/no-array-index-key
          subItems.map(function (item) {
            return (
              /*#__PURE__*/
              React.createElement(A, {
                style: {
                  display: 'block',
                  fontWeight: 'bold'
                },
                key: item.url,
                py: 5,
                href: item.url,
                onClick: function onClick(e) {
                  if (item.is_js_driven) {
                    e.preventDefault();
                    window.zE.activate({
                      hideOnClose: true
                    });
                  }
                }
              }, item.name)
            );
          }))
        );
      }),
      /*#__PURE__*/
      React.createElement(InnerFlexBox, {
        width: landing ? [1, 1, 2 / 3, 1 / 4] : [1, 1, 2 / 3, 1 / 5],
        mt: landing ? [3, 3, 0, 0] : [3, 3, 0, 0]
      },
      /*#__PURE__*/
      React.createElement(layout.Box, {
        mb: [0, 0, 0, 3],
        width: [1, 1 / 2, 1 / 2, 1]
      }, businessHourInfo.telephone &&
      /*#__PURE__*/
      React.createElement(typography.Paragraph, {
        weight: "bold"
      }, "TEL: ".concat(businessHourInfo.telephone)), businessHourInfo.hours &&
      /*#__PURE__*/
      React.createElement(HoursInfo, {
        dangerousHTML: businessHourInfo.hours
      })),
      /*#__PURE__*/
      React.createElement(layout.Box, {
        mt: [3, 0, 0, 0],
        width: [1, 1 / 2, 1 / 2, 1]
      }, others.map(function (item) {
        return item.url ?
        /*#__PURE__*/
        React.createElement(A, {
          key: item.name,
          href: item.url,
          target: "_blank",
          style: {
            fontWeight: 'bold',
            display: 'block'
          }
        }, item.name) :
        /*#__PURE__*/
        React.createElement(typography.Paragraph, {
          key: item.name,
          weight: "bold"
        }, item.name);
      })))))),
      /*#__PURE__*/
      React.createElement(layout.Box, {
        variant: "d"
      },
      /*#__PURE__*/
      React.createElement(LegalContainer, {
        px: [3, 3, 3, 4]
      },
      /*#__PURE__*/
      React.createElement(Flex, {
        p: [2, 2, 4],
        pt: [4, 4, 4],
        style: {
          justifyContent: 'flex-end'
        }
      }, legals.map(function (item, index) {
        return (
          /*#__PURE__*/
          React.createElement(layout.Box, {
            key: item.name,
            pb: [5, 5, 2],
            mr: [1, 5]
          },
          /*#__PURE__*/
          React.createElement(A, {
            href: item.url,
            target: landing ? 'blank' : ''
          }, item.name))
        );
      })), footerPolicy &&
      /*#__PURE__*/
      React.createElement(FooterPolicySection, {
        item: footerPolicy
      }),
      /*#__PURE__*/
      React.createElement(DisclaimersBox, {
        pb: landing ? [150, 150, 70] : [70]
      }, disclaimers.map(function (disclaimer, index) {
        return (
          /*#__PURE__*/
          React.createElement(typography.Small, {
            key: index,
            color: "text",
            dangerousHTML: disclaimer
          })
        );
      })))))
    );
  };

  Footer.propTypes = {
    children: PropTypes.node,
    landing: PropTypes.bool
  };
  exports.Footer = Footer;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});